module.exports = __webpack_public_path__ + "img/img7.6a47a8df.png";